export const googleKeyEnv = {
    "production": {
        "GOOGLE_KEY": process.env.VUE_APP_GOOGLE_MAPS_KEY
    },
    "development": {
        "GOOGLE_KEY": process.env.VUE_APP_GOOGLE_MAPS_KEY_DEV
    }
};